import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import axios from "../../../api/axios";
import { PRODUCT_LIST_CONFIG_URL } from "../../../api/api_routing_urls";

import ProductCard from "../../../reusable-components/product-card/product-card.component";
import AnimatedLoader from "../../../reusable-components/loader/animated_loader.component";

const ExploreProducts = () => {
  const [productList, setProductList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const getProductListDetails = async () => {
    try {
      const response = await axios.get(PRODUCT_LIST_CONFIG_URL);
      // console.log("response", { response });
      if (response.status === 200) {
        setProductList(
          response?.data?.productCompleteDetails
            ?.get_products_complete_details_v2
        );

        setIsLoading(false);
      }
      if (response.status === 202) {
        console.log("Product List details not found in the system.", "error");
        setIsLoading(false);
      }
    } catch (error) {
      console.error(error);
      if (!error?.response) {
        console.log("No Server Response");
      } else if (error.response.status === 422) {
        console.log("Some of the required inputs were not provided.", "error");
      } else {
        console.log(
          "Whoops!!!! This doesn't feel right. There might be an issue. Please contact the administrator.",
          "error"
        );
      }
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let isMounted = true;

    if (isMounted) {
      getProductListDetails();
    }
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <section className="pt-14 lg:pt-20">
      <>
        {isLoading ? (
          <div className="bg-white h-screen flex items-center justify-center">
            <AnimatedLoader />
          </div>
        ) : (
          <section className="noSelect font-tenorsans">
            <div>
              {productList?.length > 0 ? (
                <div className="px-3 grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                  {productList?.map((productObj) => (
                    <div key={productObj?.product_id}>
                      <Link
                        to={`/view-product-details/${productObj?.product_id}`}
                      >
                        <ProductCard
                          productObj={productObj}
                          productid={productObj?.product_id}
                          productthumbnail={
                            productObj?.product_images[0]?.file_url
                          }
                        />
                      </Link>
                    </div>
                  ))}
                </div>
              ) : (
                <article>
                  <div className="mt-20 text-center">
                    Products are going to available soon.
                  </div>
                </article>
              )}
            </div>
          </section>
        )}
      </>
    </section>
  );
};

export default ExploreProducts;
